import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { IonicModule } from "@ionic/angular";
import { DeliveryCardSkeletonComponent } from "./delivery-card-skeleton.component";

@NgModule(
    {
        declarations: [
            DeliveryCardSkeletonComponent,
        ],
        imports: [
            CommonModule,
            IonicModule,
        ],
        exports: [
            DeliveryCardSkeletonComponent,
        ],
        providers: [],
    })

export class DeliveryCardSkeletonModule {
}
